//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var BASE_URL = "/prototype/properties/reports";
import { createExport } from "@/mixins/createExport";
import Moment from "moment";

export default {
  mixins: [createExport],
  data: function data() {
    return {
      date_period: Moment().toDate(),
      headers: ["Unit", "Type", "Sq Ft", "Resident", "Status", { title: "Available", filter: "dateFull" }, { title: "Move In", filter: "dateFull" }, { title: "Lease Start", filter: "dateFull" }, { title: "Lease Expire", filter: "dateFull" }, { title: "Move Out", filter: "dateFull" }, { title: "Mkt Rent", filter: "toCurrency" }, { title: "Pro Forma", filter: "toCurrency" }, { title: "Lease Rent", filter: "toCurrency" }, { title: "Rent Charges", filter: "toCurrency" }, { title: "Deposit", filter: "toCurrency" }],
      fields: ["unit_name", "unit_type", "unit_type_square_feet", "resident_name", "unit_status", "available_date", "unit_lease_move_in", "unit_lease_start", "unit_lease_expiration", "unit_lease_move_out", "unit_market_rent", "unit_type_pro_forma", "unit_lease_rent", "unit_lease_charges_rent", "unit_lease_resident_deposit"],
      sectionSelected: 'Rent Roll',
      items: [],
      groupItems: [],
      sortedItems: [],
      totals: [],
      first_rec_trans: [],
      rec_trans: [],
      leaseErrorHeaders: ["Unit", "Resident", "Description"],
      leaseErrorFields: ["unit_name", "resident_name", "description"],
      leaseErrors: null,
      loading: true,
      report_types: ['Rent Roll', 'Detailed Rent Roll']
    };
  },
  props: ["reportId", "reportType", "reportTable"],
  created: function created() {
    Event.$on("rent-roll-view-lease-error", this.viewLeaseError);
    Event.$on("exportRentRollToExcel", this.exportToExcel);
    Event.$on("exportRentRollToPdf", this.exportToPdf);
  },
  beforeDestroy: function beforeDestroy() {
    Event.$off("rent-roll-view-lease-error");
    Event.$off("exportRentRollToExcel");
    Event.$off("exportRentRollToPdf");
  },
  mounted: function mounted() {
    this.load();
  },

  methods: {
    viewLeaseError: function viewLeaseError(item) {
      if (item.resident_id) {
        this.$parent.showModal = false;
        axios.get("/prototype/resident/" + item.resident_id).then(function (response) {
          var resident = response.data;
          Event.$emit("view-resident-details", resident);
        });
      } else if (item.unit_id) {
        this.$parent.showModal = false;
        Event.$emit("manually-select-tab", { name: "units" });
        Event.$emit("view-unit", item.unit_id);
      }
      return true;
    },
    datePeriodChange: function datePeriodChange(date_period) {
      this.date_period = date_period[0];
      this.load();
    },
    load: function load() {
      var _this = this;

      this.loading = true;

      axios.post("/prototype/reporting/get-report", {
        type: this.reportId,
        table: this.reportTable,
        date_period: Moment(this.date_period).format("YYYY-MM-DD"),
        start_of_month: Moment(this.date_period).startOf("month").format("YYYY-MM-DD"),
        end_of_month: Moment(this.date_period).endOf("month").format("YYYY-MM-DD"),
        section: this.sectionSelected
      }).then(function (response) {
        if (response.data) {
          _this.items = response.data.result;
          _this.groupItems = response.data.group_result;
          _this.sortedItems = Object.keys(_this.groupItems).sort(function (item1, item2) {
            var unit1 = _this.groupItems[item1][0].unitName;
            var unit2 = _this.groupItems[item2][0].unitName;

            return unit1 - unit2 < 0 ? -1 : 1;
          });
          _this.totals = response.data.totals;
          _this.first_rec_trans = response.data.first_rec_trans;
          _this.rec_trans = response.data.rec_trans;
          _this.leaseErrors = response.data.leaseErrors && response.data.leaseErrors.length ? response.data.leaseErrors : null;
          _this.loading = false;
        }
      }).catch(function (err) {
        _this.loading = false;
        _this.snotify.error("Failed to load rent roll");
        console.log(err);
      });
    },
    exportToExcel: function exportToExcel() {
      Event.$emit("export-report", {
        type: this.reportId,
        table: this.reportTable,
        date_period: Moment(this.date_period).toDate(),
        start_of_month: Moment(this.date_period).startOf("month").format("YYYY-MM-DD"),
        end_of_month: Moment(this.date_period).endOf("month").format("YYYY-MM-DD"),
        section: this.sectionSelected
      });
    },
    exportToPdf: function exportToPdf() {
      var _this2 = this;

      axios({
        url: "/prototype/reporting/export-pdf-report",
        method: "POST",
        responseType: "blob", // important
        data: {
          periodStart: "", //@TODO: normalize these to start_date, end_date
          periodEnd: "",
          glStart: "",
          glEnd: "",
          exportPdf: true
        }
      }).then(function (response) {
        var url = window.URL.createObjectURL(new Blob([response.data]));
        var link = document.createElement("a");
        link.href = url;

        var filename = "rent-roll-report" + " - " + localStorage.getItem("property-name");

        // @TODO: set up the dates consistently like other reports
        // if (data.start_date){
        //     filename = filename + ' - ' + moment(data.start_date).format('YYYYMMDD');
        //     filename = filename + '-' + moment(data.end_date).format('YYYYMMDD');
        // }

        filename = filename + " - " + moment(_this2.date_period).format("YYYY-MM-DD");
        filename = filename + ".pdf";

        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        _this2.loading = false;
      });
    },
    exportDetailedReport: function exportDetailedReport() {
      this.loading = true;

      var data = {
        type: this.reportId,
        table: this.reportTable,
        orientation: 'landscape',
        date_period: Moment(this.date_period).format("YYYY-MM-DD"),
        start_of_month: Moment(this.date_period).startOf("month").format("YYYY-MM-DD"),
        end_of_month: Moment(this.date_period).endOf("month").format("YYYY-MM-DD"),
        section: this.sectionSelected,
        total: this.totals

      };

      this.createExport(data, "/prototype/reporting/export-pdf", "detailed-rent-roll", ".pdf");

      this.loading = false;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/reports/NewRentRollReport.vue
// module id = gxjk
// module chunks = 0 1